import { Injectable } from '@angular/core'
import { LocalStorageService } from './local-storage.service'
import { StringHelper } from '../helpers/strings.helper'
import { ApiClientHelper } from '../helpers/api-client.helper'
import { AppConfig } from '../../shared/config/app-config'

@Injectable({
    providedIn:'root'
})
export class BusinessExpansionService {
    //public businesses1 = new Subject();
    constructor(
        private apiClientHelper: ApiClientHelper,
        private localStorage: LocalStorageService,
        public config: AppConfig,
    ) {
      
    }
getLoanProgrames(){
  const url = `${this.config.KUWEGO_LOANS}/api/v1/moniepoint-loan-programs/sme-business-products`;
		return this.apiClientHelper.getForPromise(url);
}

getDisburstments(id){
    const url = `${this.config.KUWEGO_LOANS}/api/v1/accounts/business-owner/${id}/disbursement`;
    return this.apiClientHelper.getForPromise(url);
}

getRepayments(id){
    const url = `${this.config.KUWEGO_LOANS}/api/v1/accounts/business-owner/${id}/repayment`;
    return this.apiClientHelper.getForPromise(url);
}

getRelationships(){
    const url = `${this.config.KUWEGO_LOANS}/api/v1/relationships`;
    return this.apiClientHelper.getForPromise(url);
}
getOccupations(params){
    const queryString = StringHelper.toUrlString(params);
    const url = `${this.config.KUWEGO_LOANS}/repo/occupations?${queryString}`;
    return this.apiClientHelper.getForPromise(url);
}
// repo/states/by-country/:countryId?page=0&size=20
getStates(id,params){
    const queryString = StringHelper.toUrlString(params);
    const url = `${this.config.KUWEGO_LOANS}/repo/states/by-country/${id}?${queryString}`;
    return this.apiClientHelper.getForPromise(url);
}

getLgs(id,params){
    const queryString = StringHelper.toUrlString(params);
    const url = `${this.config.KUWEGO_LOANS}/repo/states/by-country/${id}?${queryString}`;
    return this.apiClientHelper.getForPromise(url);
}
///bvn/get-bvn-details
getBvnDetail(payLoad){
    const strippedBody = StringHelper.removeEmptyValues(payLoad);
    const url = `${this.config.KUWEGO_LOANS}/bvn/get-bvn-details`;
    return this.apiClientHelper.postForPromise(url,strippedBody);
}

requestBusinessLoan(payLoad){
    const strippedBody = StringHelper.removeEmptyValues(payLoad);
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loans`;
    return this.apiClientHelper.postForPromise(url,strippedBody);
}

getBusinessOwners(params, status = 'active'){
   
    const urlString = StringHelper.toUrlString(params);
    const url = `${this.config.MONIEPOINT_HOST}/api/v2/business-owners/${status}?${urlString}`;
    return this.apiClientHelper.getForPromise(url);
}
//business-loan-requests/relationship-manager
getLoanRequests(params){
    const queryString = StringHelper.toUrlString(params);
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loan-requests/relationship-manager?${queryString}`;
    return this.apiClientHelper.getForPromise(url);
}

getBusinessOwnerPendingLoanRequest(){
    // const queryString = StringHelper.toUrlString(params);
    // const url = `${this.config.KUWEGO_LOANS}/api/v1/business-owner-loan-requests?${queryString}`;
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-owner-loan-requests/pending`;
    return this.apiClientHelper.getForPromise(url); 
}
getBusinessOwnerPendingLoanRequestById(id){
    
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-owner-loan-requests/${id}`;
    return this.apiClientHelper.getForPromise(url); 
}
rMgetBusinessOwnerPendingLoanRequestById(id){
    
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loan-requests/relationship-manager/details/${id}`;
    return this.apiClientHelper.getForPromise(url); 
}
BusinessOwnerDeclineLoan(payLoad){
    const strippedBody = StringHelper.removeEmptyValues(payLoad);
    const url = `${this.config.KUWEGO_LOANS}/api/v1/loan-offers/reject`;
    return this.apiClientHelper.postForPromise(url,strippedBody);
}
BusinessOwnerAcceptLoan(payLoad){
    const strippedBody = StringHelper.removeEmptyValues(payLoad);
    const url = `${this.config.KUWEGO_LOANS}/api/v1/loan-offers/accept`;
    return this.apiClientHelper.postForPromise(url,strippedBody);
}

getBusinessOwnerActiveLoanService(){
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loans/active-loans`;
    return this.apiClientHelper.getForPromise(url); 
} 

getBusinessOwnerLoanHistoryService(params){
    const queryString = StringHelper.toUrlString(params);
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loans?${queryString}`;
    return this.apiClientHelper.getForPromise(url); 
}
newGetBusinessOwnerLoanHistoryService(params){
    const queryString = StringHelper.toUrlString(params);
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loans/completed-loans?${queryString}`;
    return this.apiClientHelper.getForPromise(url);  
}  
getRmActiveLoanHistoriesService(params){
    const queryString = StringHelper.toUrlString(params);
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loans/relationship-manager-loans?${queryString}`;
    return this.apiClientHelper.getForPromise(url);
}
acceptDeclineLoanRequestBusinessOwner(payLoad){
    const strippedBody = StringHelper.removeEmptyValues(payLoad);
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loan-requests/business-owner-review`;
    return this.apiClientHelper.postForPromise(url,strippedBody); 
}
getBussineOwnerLoanDetailsService(id){
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loans/${id}`;
    return this.apiClientHelper.getForPromise(url); 
}
///
rmGetBussineOwnerLoanDetailsService(id){
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loans/relationship-manager-loans/${id}`;
    return this.apiClientHelper.getForPromise(url); 
}

rmGetRepaymentScheduleService(id){
    const url = `${this.config.KUWEGO_LOANS}/api/v1/repayment-schedules/business-loan/${id}/relationship-manager`;
    return this.apiClientHelper.getForPromise(url); 
}

businessOwnerGetRepaymentScheduleService(id){
    const url = `${this.config.KUWEGO_LOANS}/api/v1/repayment-schedules/business-loan/${id}/business-owner`;
    return this.apiClientHelper.getForPromise(url); 
}
getRmLoanDetailsService(){
    const url = `${this.config.KUWEGO_LOANS}/api/v1/relationship-managers/details`;
    return this.apiClientHelper.getForPromise(url); 
}
getBusinessOwnerLoanDetailsService(){
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-owners/access`;
    return this.apiClientHelper.getForPromise(url); 
}
verifiedResidentialAddressService(payLoad){
    const strippedBody = StringHelper.removeEmptyValues(payLoad);
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loan-requests/update-business-owner-address`;
    return this.apiClientHelper.postForPromise(url,strippedBody); 
}
verifiedBusinessAddressService(payLoad){
    const strippedBody = StringHelper.removeEmptyValues(payLoad);
    const url = `${this.config.KUWEGO_LOANS}/api/v1/business-loan-requests/update-business-address`;
    return this.apiClientHelper.postForPromise(url,strippedBody); 
}
}
